import type { LiteUserOut } from '@repo/api-codegen';
import { UserAvatar } from '@repo/common/components/UserAvatar';
import { EntityType } from '@repo/common/enums/entityType';
import { Icon } from '@repo/foundations/components/Icon';
import { memo } from 'react';
import IntegrationLogo from '../IntegrationLogo';
import { USER_PERFORMER_TYPES, type IActivityLogPerformer } from './types';

export const ActivityLogPerformerIcon = memo(
	({ performer }: { performer: IActivityLogPerformer }) => {
		if (USER_PERFORMER_TYPES.includes(performer.type)) {
			return <UserAvatar size="xs" user={performer.metadata as LiteUserOut} />;
		}

		if (performer.type === 'AUTOMATION') {
			return <Icon name="bolt" />;
		}

		if (performer.type === 'EXTRACTION' || performer.type === 'INTEGRATION') {
			return (
				<IntegrationLogo
					entityType={EntityType.integration}
					integrationId={performer.metadata.id}
					integrationType={performer.metadata.integration_type ?? undefined}
					size={16}
				/>
			);
		}

		if (performer.type === 'UNKNOWN') {
			return <Icon name="user" />;
		}

		return null;
	}
);
